module.exports = __webpack_public_path__ + "static/media/shop.321f144d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop.svg
// module id = 596
// module chunks = 1